import LoginRecover from './LoginRecover';

export default LoginRecover;
